// Checkbox.tsx
import React from 'react';
import { Checkbox as MUICheckbox, styled } from '@mui/material';
import Colors from '../global/Colors';

// Define the props interface
interface CheckboxProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  colorMode?: 'dark' | 'light';
  disabled?: boolean;
  size?: number; // pixel size for both width and height
}

// Styled wrapper that adapts to light/dark modes similar to Toggle
const Checkbox = styled(({ checked = false, onChange = () => {}, colorMode = 'light', disabled = false, size = 28.5, ...props }: CheckboxProps) => (
  <MUICheckbox
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    {...props}
    sx={(theme) => {
      const isDark = colorMode === 'dark';
      
      const baseColor = isDark ? Colors.grey6 : Colors.grey2; 
      const checkedColor = isDark ? Colors.white : Colors.grey6;

      const disabledIconColor = Colors.grey5+80;
      const disabledBackgroundColor = Colors.grey5+50;

      return {
        color: baseColor,
        padding: 0,
        width: size,
        height: size,
        '& .MuiSvgIcon-root': {
          fontSize: size,
        },
        '&.Mui-checked': {
          color: checkedColor,
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&.Mui-disabled': {
            borderColor: disabledBackgroundColor,
            color: disabledIconColor,
            // borderRadius: '4px',
        },
      };
    }}
  />
))(({ theme }) => ({}));

export default Checkbox;